module.exports = __webpack_public_path__ + "assets/img/Ram-Group-Website-w960.6beb772e.webp";